/* eslint-disable react/prop-types */
/*
Author: Gilang Romadhanu Tartila
*/

import * as React from 'react';
import { useSelector } from 'react-redux';
import {
  createStackNavigator,
  CardStyleInterpolators,
} from '@react-navigation/stack';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { isWeb } from '@global/screens';
import {
  setTitleHeader,
  setDefaultStackOption,
  hasNoAccess,
} from '@global/helpers';

import HamburgerButton from '@components/navbar/HamburgerButton';
import NotificationSettingButton from '@components/navbar/NotificationSettingButton';
import BackButton from '@components/navbar/BackButton';
import ActionButton from '@components/navbar/ActionButton';

import BudgetPocketScreen from '@/screens/setting/budget-pocket/BudgetPocketScreen';
import BudgetPocketDetailScreen from '@/screens/setting/budget-pocket/BudgetPocketDetailScreen';
import BudgetPocketFormScreen from '@/screens/setting/budget-pocket/BudgetPocketFormScreen';

const Stack = createStackNavigator();

// eslint-disable-next-line react/prop-types
const BudgetPocketNavigator = ({ navigation }) => {
  const insets = useSafeAreaInsets();
  const tempData = useSelector((state) => state.global.tempData);
  const isEditAccess = tempData !== 'need_approval';

  const goToForm = (props, isAdd = false) => {
    if (
      !isAdd &&
      props &&
      props.route &&
      props.route.params &&
      props.route.params.id
    ) {
      props.navigation.navigate('BudgetPocketFormScreen', {
        titleScreen: props.route.params.name,
        name: props.route.params.name,
        id: props.route.params.id,
      });
    } else {
      props.navigation.navigate('BudgetPocketFormScreen');
    }
  };

  const hasAccess = !hasNoAccess(['superadmin', 'marketing_admin', 'general']);

  return (
    <Stack.Navigator
      initialRouteName="BudgetPocketScreen"
      screenOptions={(props) => ({
        headerLeft: () => <HamburgerButton {...props} />,
        headerRight: () => <NotificationSettingButton {...props} />,
        ...setDefaultStackOption(insets, CardStyleInterpolators),
      })}>
      <Stack.Screen
        name="BudgetPocketScreen"
        component={BudgetPocketScreen}
        options={() => ({
          // headerRight (incl. the mobile Add) is owned by BudgetPocketScreen so
          // Add goes through openChild and preserves the list on return.
          title: setTitleHeader('Budget Pocket'),
        })}
      />
      <Stack.Screen
        name="BudgetPocketFormScreen"
        component={BudgetPocketFormScreen}
        options={(props) => {
          const route = props.route;
          let title = 'Add Budget Pocket';
          let isEdit = false;
          let params = {};
          if (route.params && route.params.titleScreen) {
            title = route.params.titleScreen;
            isEdit = true;
            params = route.params;
          }
          return {
            title: setTitleHeader(title),
            headerLeft: () => (
              <BackButton
                {...props}
                // navigate() (pop) not replace() — create->back preserves the
                // migrated list instance (openChild).
                isJump={true}
                customBack={{
                  screen: isEdit
                    ? 'BudgetPocketDetailScreen'
                    : 'BudgetPocketScreen',
                  params: params,
                }}
              />
            ),
            headerRight: isWeb
              ? () => <NotificationSettingButton {...props} />
              : false,
          };
        }}
      />
      <Stack.Screen
        name="BudgetPocketDetailScreen"
        component={BudgetPocketDetailScreen}
        options={(props) => {
          const route = props.route;
          let title = 'Budget Pocket Detail';
          if (route.params && route.params.titleScreen) {
            title = route.params.titleScreen;
          }
          const goBack = () => {
            props.navigation.navigate('BudgetPocketScreen');
          };
          return {
            title: setTitleHeader(title),
            headerLeft: () => (
              <BackButton
                {...props}
                onPress={() => goBack()}
                notUseLastRoute={true}
              />
            ),
            headerRight: () =>
              isWeb ? (
                <NotificationSettingButton {...props} />
              ) : hasAccess && isEditAccess ? (
                <ActionButton
                  icon={require('@assets/img/icons/edit-white.svg')}
                  onCallback={() => goToForm(props)}
                />
              ) : (
                false
              ),
          };
        }}
      />
    </Stack.Navigator>
  );
};

export default BudgetPocketNavigator;
